module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner userFill",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "pgScroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "pgHead"
  }, [_c('span', [_vm._v("朝企家 | 帐号注册")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pgBody",
    style: ('height:' + (_vm.pageH - 60) + 'px;')
  }, [_c('el-steps', {
    attrs: {
      "active": 2,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "基本信息"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "完成注册"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "平台审核"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("注册信息已提交，平台审核中")]), _vm._v(" "), _c('div', {
    staticClass: "tipsc"
  }, [_vm._v("审核成功后，会以短信方式通知您")]), _vm._v(" "), _c('div', {
    staticClass: "tipsc"
  }, [_vm._v("审核时间，工作日9:00-11:00，14:00-17:00")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-5ef3c375"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/register/successFill.vue
// module id = 1503
// module chunks = 1